import React, {useEffect, useRef, useState} from 'react';
import RawLayout from "@/components/layout/main/rawLayout";
import {useApiReadAcademyId} from "@/api/academy";
import {myAcademy} from "@/lib/services/academyService";
import TextToHTML from "@/components/text-to-html";
import {Alert, Button, Divider, Input, Select, Spin} from "antd";
import {useApiLocationCountry} from "@/api/location";
import {URLS} from "@/lib/urls";
import {Link, useNavigate} from "react-router-dom";
import {useApiCreateStudentUserAcademyRegister} from "@/api/userAcademy";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import UploadCMP from "@/components/upload";
import ProvinceCityCMP from "@/components/provinceCity";
import CleaveInput from "@/components/cleave-input/cleaveInput";
import RenderIf from "@/components/render-if";

function FirstCompleteProfilePage() {

    const [myCountry, setMyCountry] = useState('IR')
    const [selectedGender, setSelectedGender] = useState()
    const [options, setOptions] = useState({})
    const [countryList, setCountryList] = useState([])
    const [city, setCity] = useState()
    const [province, setProvince] = useState()
    const [nationalCardPicture, setNationalCardPicture] = useState()
    const navigate = useNavigate()
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [showFormSignup, setShowFormSignup] = useState(false);
    const formRef = useRef(null);
    const [birthDate, setBirthDate] = useState()
    const [passportDate, setPassportDate] = useState()
    const [nationalCode, setNationalCode] = useState()
    const [rawNationalCode, setRawNationalCode] = useState()

    const {mutate: RegisterUserAcademy, isPending} = useApiCreateStudentUserAcademyRegister()

    const {
        data: academy,
        isSuccess: isSuccessAcademyDetail,
        isPending: isPendingAcademyDetail
    } = useApiReadAcademyId(myAcademy('id'))


    const {data: country} = useApiLocationCountry()

    useEffect(() => {
        setCountryList(country?.data)
    }, [country])


    useEffect(() => {
        if (academy?.data) {
            setShowFormSignup(!(academy?.data?.data?.termcondition || academy?.data?.data?.welcomemessage) || !academy?.data?.data?.termcondition)
            setOptions(academy?.data?.data?.config)
        }
    }, [academy?.data]);

    useEffect(() => {
        if (academy?.data?.data?.limitations?.iranianperson) {
            setMyCountry('IR')
        }
    }, [academy?.data]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formRef.current) return;

        const formData = new FormData(formRef.current);

        const formDataJson = Object.fromEntries(formData.entries());


        formDataJson.nationality = myCountry
        formDataJson.birthdate = birthDate

        if (myCountry === 'IR') {
            formDataJson.nationalcode = rawNationalCode
        }

        formDataJson.pasportdate = passportDate
        formDataJson.gender = selectedGender
        formDataJson.city = city
        formDataJson.province = province
        formDataJson.nationalCardPicture = nationalCardPicture?.file?.response?.data?.id

        RegisterUserAcademy(formDataJson, {
            onSuccess: (e) => {
                ApiHandleSuccessMessage(e)
                navigate(URLS.student.dashboard)
            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }

        })
    };
    // Handlers
    const handleAcceptTerms = () => {
        setAcceptTerms(!acceptTerms);
        setShowFormSignup(true);
    };


    // Helper renderers for blocks
    const renderGender = () => (
        <div className="mb-2">
            <label htmlFor="gender">جنسیت <small className="text-red-600">*</small></label>
            <Select
                className={'block'}
                placeholder={'انتخاب کنید'}
                id={'gender'}
                onChange={(e) => setSelectedGender(e)}
                options={[
                    {value: 'male', label: 'مرد'},
                    {value: 'female', label: 'زن'},
                ]}
            />
        </div>
    );

    const renderName = () => (
        <div>
            <label htmlFor="firstname" className="block">نام <small className="text-red-600">*</small></label>
            <Input
                type="text"
                name="firstname"
                id="firstname"
                placeholder="نام *"
                maxLength={40}
                minLength={1}
            />
        </div>
    );

    const renderFamily = () => (
        <div>
            <label htmlFor="lastname" className="block">نام خانوادگی <small className="text-red-600">*</small></label>
            <Input
                type="text"
                name="lastname"
                id="lastname"
                placeholder="نام خانوادگی *"
                maxLength={60}/>
        </div>
    );

    const renderFather = () => (
        <div>
            <label htmlFor="father" className="block">نام پدر <small className="text-red-600">*</small></label>
            <Input type="text" name="father" id="father" placeholder="نام پدر *" maxLength={50} required
            />
        </div>
    );


    const renderBirthday = () => (
        <div>
            <label htmlFor="birthdate" className="block">تاریخ تولد <small className="text-red-600">*</small></label>
            <CleaveInput
                value={birthDate}
                style={{direction: 'ltr'}}
                type="tel" name="birthdate" id="birthdate" placeholder="مثال: 1369/04/15 *"
                autoComplete="off"
                options={{delimiter: '/', blocks: [4, 2, 2]}}
                onChange={(e) => {
                    setBirthDate(e.target.value)
                }}
            />

        </div>
    );

    const renderCountry = () => (
        <div>
            {countryList && countryList.length > 0 ? (
                <>
                    <label htmlFor="nationality" className="block">ملیت</label>

                    <Select
                        className={'block'}
                        placeholder={'انتخاب کنید'}
                        id={'nationality'}
                        onChange={(e) => setMyCountry(e)}
                        options={countryList.map((value, i) => {
                            return {value: value.key, label: value.fa_name}
                        })}
                    />
                </>
            ) : null}

        </div>
    );

    return (
        <RawLayout>

            <div className="flex flex-col items-center w-full mt-8">
                {isPendingAcademyDetail && <Spin spinning={true} size={'large'}/>}
                {!showFormSignup && <>
                    {(academy?.data?.data?.welcomemessage || academy?.data?.data?.termcondition) && (
                        <div className="flex justify-center w-full">
                            <div className="w-full max-w-2xl bg-white rounded shadow p-6 mb-6" id="academyTermText">
                                {academy?.data?.data?.welcomemessage && (
                                    <TextToHTML>{academy?.data?.data?.welcomemessage}</TextToHTML>
                                )}
                                {academy?.data?.data?.termcondition && (
                                    <>
                                        <h3 className="text-lg font-bold mb-2">شرایط و ضوابط</h3>
                                        <TextToHTML>{academy?.data?.data?.termcondition}</TextToHTML>
                                        <div className="flex items-center justify-center mb-2 mt-4">
                                            <Button type={'primary'} onClick={() => handleAcceptTerms()}>
                                                از شرایط و قوانین مطلع شدم و آن را می‌پذیرم
                                            </Button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </>}
                {/* Welcome message and terms */}

                {/* Signup form */}
                {showFormSignup && (
                    <div className="flex justify-center w-full" data-response="accept">
                        <div className="w-full max-w-xl bg-white rounded shadow p-6 mb-6">
                            <div className={'font-bold text-xl text-center mb-2'}>
                                فرم ثبت‌نام
                            </div>
                            <form method="post" autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
                                <Alert type={'info'} className={'mb-4'}
                                       description={'برای ثبت‌نام در این مرکز آموزشی فرم زیر را تکمیل کنید'}/>

                                <>
                                    <RenderIf condition={!!academy?.data?.data?.limitations?.iranianperson}
                                              falsyElement={renderCountry()}
                                    >

                                        <input type="hidden" name="nationality" value="IR"/>
                                    </RenderIf>


                                    {!(options?.register_by_sabtahval && myCountry === 'IR') && (
                                        <div className={'mt-2'}>
                                            {renderGender()}
                                        </div>)}

                                    {myCountry === 'IR' && <>
                                        <div>
                                            <label htmlFor="nationalcode" className="block mt-2">کد ملی <small
                                                className="text-red-600">*</small></label>
                                            <CleaveInput
                                                id="nationalcode"
                                                value={nationalCode}
                                                style={{direction: 'ltr'}}
                                                type="tel" placeholder="کد ملی ۱۰ رقمی *"
                                                autoComplete="off"
                                                options={{delimiter: ' - ', blocks: [3, 6, 1]}}
                                                onChange={(e) => {
                                                    setNationalCode(e.target.value)
                                                    setRawNationalCode(e.target.rawValue)
                                                }}
                                            />

                                        </div>
                                    </>}

                                    {options?.register_by_sabtahval && myCountry === 'IR'
                                        ? <></>
                                        : <>
                                            <div className="gap-2 mt-2">
                                                {renderName()}
                                            </div>
                                            <div className="mt-2">
                                                {renderFamily()}
                                            </div>
                                        </>}


                                    {!(options?.register_by_sabtahval && myCountry === 'IR') && (
                                        <div className={'mt-2'}>{renderFather()}</div>)}

                                    <div className="mt-2">
                                        {renderBirthday()}
                                    </div>


                                    {myCountry !== 'IR' && <>
                                        <div className="mt-2">
                                            <div className="">
                                                <label htmlFor="pasportcode" className="block">شماره گذرنامه <small
                                                    className="text-red-600">*</small></label>
                                                <Input type="tel" name="pasportcode" id="pasportcode"
                                                       style={{direction: 'ltr'}}
                                                       placeholder="شماره گذرنامه *"
                                                       maxLength={15}/>
                                            </div>
                                            <div className="mt-2">
                                                <label htmlFor="passportexpire" className="block">تاریخ انقضای
                                                    گذرنامه <small
                                                        className="text-red-600">*</small></label>
                                                <CleaveInput
                                                    value={passportDate}
                                                    style={{direction: 'ltr'}}
                                                    type="tel" id="passportexpire" placeholder="مثال: 1405/04/15 *"
                                                    autoComplete="off"
                                                    options={{delimiter: '/', blocks: [4, 2, 2]}}
                                                    onChange={(e) => {
                                                        setPassportDate(e.target.value)
                                                    }}
                                                />

                                            </div>
                                        </div>
                                    </>}
                                </>

                                {/* City select */}
                                {academy?.data?.data?.requiredfield?.member?.provincecity && (
                                    <ProvinceCityCMP setCity={setCity} setProvince={setProvince}/>
                                )}
                                {/* National card photo */}
                                {academy?.data?.data?.requiredfield?.member?.nationalthumb && (<div className={'mt-2'}>
                                    <UploadCMP label={'تصویر کارت ملی'} dragMode={true}
                                               afterUploadFn={(file) => setNationalCardPicture(file)}/>

                                </div>)}
                                {/* Referer */}
                                {academy?.data?.data?.referersystem && (
                                    <div className="mt-2">
                                        <label htmlFor="referer" className="block">معرف <small
                                            className="text-green-600">(اختیاری)</small></label>
                                        <Input style={{direction: 'ltr'}} type="tel" name="referer" id="referer"
                                        />
                                    </div>
                                )}

                                <Button
                                    type="primary"
                                    htmlType={'submit'}
                                    className={'block'}
                                    rootClassName={'mt-4 w-full block'}
                                    disabled={isPending}
                                    loading={isPending}
                                >
                                    ثبت‌نام
                                </Button>


                            </form>

                            <Divider type={'horizontal'}/>
                            <div className="text-center text-blue-600">

                                <Link to={URLS.auth.logout}>خروج از حساب کاربری</Link>
                            </div>
                        </div>

                    </div>
                )}

            </div>
        </RawLayout>
    );
}

export default FirstCompleteProfilePage;